export const IS_PROD = process.env.NODE_ENV === 'production'
export const IS_DEV = process.env.NODE_ENV === 'development'
export const SITE_TITLE = process.env.PUBLIC_SITE_TITLE || 'NavTrac YMS'
export const LOAD_STORYBOOK = process.env.PUBLIC_LOAD_STORYBOOK === 'true'
export const API_URL = process.env.PUBLIC_API_URL || '//localhost:5000'
export const NAS_URL = process.env.NAS_URL || '//localhost:3000'
export const ASSET_URL = process.env.NEXT_PUBLIC_ASSET_URL || '//workset-images.navtrac.com'
export const ASSET_URL_V2 = process.env.NEXT_PUBLIC_ASSET_URL_V2 || '//img.navtrac.com'
export const ENABLE_STATE = process.env.NEXT_PUBLIC_ENABLE_STATE === 'true'
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || 'MISSING_GOOGLE_TAG_MANAGER_ID'
export const INTERCOM_ID = process.env.NEXT_PUBLIC_INTERCOM_ID || 'MISSING_INTERCOM_ID'
export const ENABLE_DEVTOOLS = process.env.NEXT_PUBLIC_ENABLE_DEVTOOLS === 'true'
export const ENABLE_MERGE_UPDATE_FOR_EDIT = /1|true/i.test(
  process.env.PUBLIC_ENABLE_MERGE_UPDATE_FOR_EDIT
)
export const ENABLE_MERGE_UPDATE_FOR_DELETE = /1|true/i.test(
  process.env.PUBLIC_ENABLE_MERGE_UPDATE_FOR_DELETE
)
